import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09d6c70b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=09d6c70b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6c70b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d6c70b')) {
      api.createRecord('09d6c70b', component.options)
    } else {
      api.reload('09d6c70b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09d6c70b&scoped=true", function () {
      api.rerender('09d6c70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jhyc/service/index.vue"
export default component.exports